// extracted by mini-css-extract-plugin
module.exports = {"container":"back-return_container__3AWGW","disable":"back-return_disable__1e-UL"};